export const permissions = [
    'bounty_manage',
    'clan_modify',
    'direct_merge',
    'external_connections_manage',
    'level_modify',
    'level_custom_copies_modify',
    'level_updates_modify',
    'level_notes_modify',
    'merge_review',
    'notifications_subscribe',
    'pack_tier_modify',
    'pack_modify',
    'placeholder_create',
    'record_modify',
    'reviewers_audit',
    'role_assign',
    'role_modify',
    'shift_manage',
    'shift_create_own',
    'submission_review',
    'submission_reviewer_visible',
    'submission_edit_non_self_claimed',
    'submission_edit_with_raw_footage',
    'submission_see_statistics',
    'submission_see_other_reviewer_statistics',
    'submission_priority',
    'submission_status_manage',
    'user_modify',
    'user_ban',
    'user_redact',
] as const;

export type Permission = (typeof permissions)[number];

export const permissionDescriptions: Record<Permission, string> = {
    level_modify: 'Allows placing and editing levels on the list',
    level_custom_copies_modify: 'Allows editing custom copy IDs for a level',
    level_updates_modify:
        'Allows editing updates for a level (nerfs, buffs, balances, etc.)',
    level_notes_modify: 'Allows editing public or reviewer notes for a level',
    record_modify: 'Allows editing existing records for a level',
    pack_tier_modify: 'Allows editing pack tiers',
    pack_modify: 'Allows editing pack and their levels',
    placeholder_create: 'Allows creating an empty placeholder user account',
    user_modify: 'Allows editing user names, country, etc',
    user_ban: 'Allows banning a user (ban_level 3)',
    user_redact: 'Allows redacting a user (ban_level 4)',
    role_assign: 'Allows assigning roles below your highest role to users',
    role_modify: 'Allows editing roles and permissions below your highest role',
    merge_review: 'Allows reviewing merge requests submitted through the site',
    direct_merge: 'Allows directly merging two users',
    clan_modify: 'Allows editing clans and their members',
    submission_review: 'Allows reviewing submissions',
    submission_reviewer_visible:
        'By default, submission reviewers are hidden. This permission makes a reviewer visible to other reviewers.',
    submission_edit_non_self_claimed:
        'Allows editing submissions that you do not have claimed through the claim system',
    submission_edit_with_raw_footage:
        'Allows editing submissions that have raw footage attached',
    submission_see_statistics:
        'Allows seeing submission statistics (total and own)',
    submission_see_other_reviewer_statistics:
        "Allows seeing other reviewers' statistics. Otherwise, you can only see your own.",
    submission_priority:
        "Sets the user's submissions to priority if they have this. (AREDL+)",
    shift_manage: 'Allows editing reviewers shifts',
    shift_create_own: 'Allows editing your own shifts',
    submission_status_manage: 'Allows opening and closing new submissions.',
    reviewers_audit:
        'Allows seeing the identity of all reviewers, including hidden ones.',
    notifications_subscribe:
        'Allows subscribing to a websocket for submissions notifications. (Used by the discord bot)',
    external_connections_manage:
        'Allows editing users external connections (Patreon)',
    bounty_manage: 'Allows editing weekly, monthly, event and bounty levels',
} as const;
